module.exports = __webpack_public_path__ + "img/cj.80e5f784.png";